var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAnnotateEraser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#annotate-eraser_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.793.5a1 1 0 0 1 1.414 0L15.5 4.793a1 1 0 0 1 0 1.414L6.207 15.5a1 1 0 0 1-1.414 0L.5 11.207a1 1 0 0 1 0-1.414zm.707.707L4.707 7 9 11.293 14.793 5.5zM1.207 10.5 4 7.707 8.293 12 5.5 14.793zm8.44-7.146 3 3 .707-.708-3-3zM16 16H7.121l1-1H16z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "annotate-eraser_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgAnnotateEraser;